import React, { useState } from 'react';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import SideMenu from './sidemenu/SideMenu';
import Map from './map/Map';

export default function AppLayout({ industrieObjects, filters, setFilters, handleFlyToIndustrieObjects, targetPosition, zoom }) {
  const isMobile = useMediaQuery('(max-width:768px)');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: 'calc(100dvh - var(--footer-height, 64px))',
        position: 'relative',
        zIndex: 1,
      }}
    >
      {isMobile && (
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            left: 10,
            zIndex: 1000,
          }}
        >
          <IconButton
            onClick={() => setMobileMenuOpen((prev) => !prev)}
            sx={{
              bgcolor: 'white',
              borderRadius: 0,
              boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
              border: '1px solid #dce1e8',
              color: '#0063a6',
              '&:hover': {
                bgcolor: '#EDF4F9',
              },
            }}
          >
            {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </Box>
      )}

      <Box
        sx={{
          position: isMobile ? 'absolute' : 'relative',
          top: 0,
          left: 0,
          width: isMobile ? (mobileMenuOpen ? '100vw' : '0') : '470px',
          transition: isMobile ? 'transform 0.3s ease' : 'width 0.3s ease',
          transform: isMobile ? (mobileMenuOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
          overflow: 'hidden',
          zIndex: 999,
          height: '100%',
          bgcolor: 'white',
          boxShadow: isMobile && mobileMenuOpen ? '0 0 24px rgba(0,0,0,0.15)' : 'none',
        }}
      >
        <SideMenu
          industrieObjects={industrieObjects}
          filters={filters}
          setFilters={setFilters}
          handleFlyToIndustrieObjects={handleFlyToIndustrieObjects}
          onCompanySelect={isMobile ? () => setMobileMenuOpen(false) : undefined}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          height: '100%',
          width: '100%',
          borderLeft: '2px solid #dce1e8',
        }}
      >
        <Map
          industrieObjects={industrieObjects}
          targetPosition={targetPosition}
          zoom={zoom}
        />
      </Box>
    </Box>
  );
}
